import React from 'react';
import {
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxDashboardWizardWrapper,
} from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/Components/TaxDashboardWizardWrapper';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

import { CondensedUploader } from './CondensedUploader';

const Layout = () => {
  const { resource, onSubmit } = useMetaLayoutContext();

  let hasAttachments = false; // Initialize

  if (resource.attr('attachmentGroups')) {
    const attachmentGroups = resource.attr('attachmentGroups')?.resources().list();
    hasAttachments = attachmentGroups.some(attachmentGroup => attachmentGroup.attr('files')?.resources().list().length > 0);
  }

  return (
    <TaxDashboardWizardWrapper
      continueDisabled={!hasAttachments}
      extraNavLabel={resource.attr('skipLabel')}
      onClickExtraNavOverride={onSubmit}
    >
      <FDStack direction="column" spacing={4}>
        <MetaControlField attr={'body'} {...dataAttrs('tax-dashboard-review-kickoff-wizard-upload-step-body')} />
        <FDStack direction={'column'} spacing={2}>
          {resource.attr('attachmentGroups')?.resources().list().map((attachmentGroup) => <CondensedUploader attachmentGroup={attachmentGroup} />)}
        </FDStack>
      </FDStack>
    </TaxDashboardWizardWrapper>
  );
};

export default Layout;
